import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useApi, errMsg } from "@/lib/api";
import { fmt } from "@/lib/dates";

const local = (iso) => (iso ? fmt(iso, "yyyy-MM-dd'T'HH:mm") : "");
const toUtc = (v) => (v ? new Date(v).toISOString() : null);

export const EntryDialog = ({ entry, name, onClose, onSaved }) => {
  const api = useApi();
  const [cin, setCin] = useState("");
  const [cout, setCout] = useState("");

  useEffect(() => {
    if (entry) {
      setCin(local(entry.clock_in));
      setCout(local(entry.clock_out));
    }
  }, [entry]);

  const run = async (fn, ok) => {
    try {
      await fn();
      toast.success(ok);
      onSaved();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={!!entry} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="entry-dialog">
        <DialogHeader>
          <DialogTitle>Registratie corrigeren</DialogTitle>
          <DialogDescription>{name}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          <div><Label htmlFor="entry-in">Ingeklokt</Label><Input id="entry-in" type="datetime-local" value={cin} onChange={(e) => setCin(e.target.value)} className="mt-1.5" data-testid="entry-clock-in-input" /></div>
          <div><Label htmlFor="entry-out">Uitgeklokt</Label><Input id="entry-out" type="datetime-local" value={cout} onChange={(e) => setCout(e.target.value)} className="mt-1.5" data-testid="entry-clock-out-input" /></div>
        </div>
        <DialogFooter className="gap-2 sm:justify-between">
          <Button variant="ghost" className="text-red-600" onClick={() => run(() => api.delete(`/time/entries/${entry.id}`), "Registratie verwijderd")} data-testid="entry-delete-button">Verwijderen</Button>
          <Button onClick={() => run(() => api.patch(`/time/entries/${entry.id}`, { clock_in: toUtc(cin), clock_out: toUtc(cout) }), "Registratie opgeslagen")} data-testid="entry-save-button">Opslaan</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
